import { getClientCode, getClientLabel } from 'actions/ui/init/initSelectors';
import {
  getFullName,
  getIsLoggedIn,
  getLangOptions,
  logout
} from 'actions/auth/login';
import UserDropdown from './UserDropdownComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getLocale } from 'actions/language/selectors';
import { getPathname } from 'actions/routes/routeSelectors';
import { replace } from 'react-router-redux';

// Component to Contain

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  isLoggedIn: getIsLoggedIn(state),
  lang: getLocale(state),
  langOptions: getLangOptions(state),
  userName: getFullName(state),
  clientLabel: getClientLabel(state),
  clientCode: getClientCode(state),
  pathname: getPathname(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      replace,
      logout
    },
    dispatch
  );
};

// Create higher-order component which feeds in specified props.
const UserDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDropdown);

export default UserDropdownContainer;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/UserDropdown/UserDropdownContainer.js